import { Train, Car, Bike, ParkingSquare, MapPin } from "lucide-react";
import ConsentGate from "@/components/site/ConsentGate";

const tiles = [
  { icon: Train, title: "ÖPNV", desc: "Bequem mit Bus & U-Bahn erreichbar." },
  { icon: Car, title: "Auto", desc: "Direkter Anschluss an die Hauptverkehrsadern." },
  { icon: Bike, title: "Fahrrad", desc: "Sichere Abstellmöglichkeiten direkt am Büro." },
  { icon: ParkingSquare, title: "Parken", desc: "Parkplätze in unmittelbarer Nähe verfügbar." },
];

export default function Location() {
  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center reveal">
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-primary text-balance">
            Anfahrt zu unserem Büro
          </h2>
          <p className="mt-4 inline-flex items-start gap-2 text-muted-foreground text-left">
            <MapPin className="w-4 h-4 text-accent shrink-0 mt-1" />
            <span>Rothenbaumchaussee 58, 20148 Hamburg</span>
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-6">
          <ConsentGate
            service="OpenStreetMap"
            className="reveal relative rounded-2xl overflow-hidden border border-border shadow-card aspect-[4/3] lg:aspect-auto min-h-[340px] bg-primary"
          >
            <iframe
              title="FINABLE Büro Hamburg"
              src="https://www.openstreetmap.org/export/embed.html?bbox=9.9839%2C53.5686%2C10.0039%2C53.5786&layer=mapnik&marker=53.5736%2C9.9889"
              className="absolute inset-0 w-full h-full border-0"
              loading="lazy"
            />
          </ConsentGate>

          <div className="grid sm:grid-cols-2 gap-4">
            {tiles.map(({ icon: Icon, title, desc }, i) => (
              <div
                key={i}
                className="reveal rounded-2xl bg-card border border-border p-5 shadow-card hover:shadow-elegant transition-all"
              >
                <div className="w-11 h-11 rounded-xl bg-accent-soft text-accent flex items-center justify-center">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="mt-4 font-display text-lg font-bold text-primary">{title}</h3>
                <p className="mt-1 text-sm text-muted-foreground">{desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Photo gallery – clean rectangular grid */}
        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3">
          {[
            { src: "/lovable-uploads/flx-91-beratung.webp", alt: "Online-Beratung am Schreibtisch", position: "object-left-top" },
            { src: "/lovable-uploads/dsc5759-tablet.webp", alt: "Beratung mit Tablet" },
            { src: "/lovable-uploads/14.webp", alt: "Lächelnder Berater" },
            { src: "/lovable-uploads/20211110_47.webp", alt: "Diskussion im Büro" },
            { src: "/lovable-uploads/20211110_37.webp", alt: "Team-Meeting", position: "object-right" },
            { src: "/lovable-uploads/L1004184-gespraech.webp", alt: "Beratungsgespräch im Sessel" },
            { src: "/lovable-uploads/L1004040.webp", alt: "FINABLE Büro", position: "object-[60%_center]" },
            { src: "/lovable-uploads/10.webp", alt: "Beratung mit Tablet", position: "object-[center_25%]" },
          ].map((img, i) => (
            <div
              key={i}
              className="reveal aspect-square overflow-hidden border border-border shadow-card hover:shadow-elegant transition-all duration-300"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <img
                src={img.src}
                srcSet={`${img.src.replace('.webp', '-400.webp')} 400w, ${img.src.replace('.webp', '-800.webp')} 800w, ${img.src.replace('.webp', '-1200.webp')} 1200w`}
                sizes="(min-width: 768px) 25vw, 50vw"
                alt={img.alt}
                width={800}
                height={800}
                loading="lazy"
                decoding="async"
                className={`w-full h-full object-cover hover:scale-105 transition-transform duration-500 ${(img as { position?: string }).position ?? ""}`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
